import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import { FormControlLabel, Switch } from '@mui/material';
import { useState } from 'react';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0
  },
  '&::before': {
    display: 'none'
  }
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.7rem', fontWeight: 700 }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, .05)' : 'rgba(0, 0, 0, .03)',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)'
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1)
  }
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)'
}));

const useStyles = makeStyles({
  overFlowContent: {
    maxHeight: '70vh',
    overflowY: 'auto'
  },
  subItem: {
    padding: '0 0 0 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '10px'
  }
});
const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)'
    }
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#1890ff'
      }
    }
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200
    })
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box'
  }
}));

export default function RolePermissionAccordian({
  handlePermissionChange,
  accordianData,
  setAccordianData
}) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState('panel1');

  const handleAccordionChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleSwitchChange = (panelId, itemId, value, status) => {
    setAccordianData((prevState) =>
      prevState.map((panel) =>
        panel.id === panelId
          ? {
              ...panel,
              labelItems: panel.labelItems.map((item) =>
                item?.id === itemId ? { ...item, status: !status } : item
              )
            }
          : panel
      )
    );
    handlePermissionChange(value, !status);
  };
  return (
    <div className={classes.overFlowContent}>
      {accordianData?.map((panel) => (
        <Accordion
          key={panel?.id}
          expanded={expanded === panel?.label}
          onChange={handleAccordionChange(panel?.label)}
        >
          <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
            <Typography
              sx={{
                fontWeight: '700',
                fontSize: { xs: '12px', md: '14px' },
                lineHeight: '18px',
                color: '#535353'
              }}
            >
              {panel?.label}
            </Typography>
          </AccordionSummary>
          {panel?.labelItems && (
            <AccordionDetails>
              {panel?.labelItems?.map((item) => (
                <div className={classes?.subItem} key={item.id}>
                  <Typography
                    sx={{
                      fontWeight: '600',
                      fontSize: { xs: '12px', md: '14px' },
                      lineHeight: '24px',
                      color: '#535353'
                    }}
                  >
                    {item?.name}
                  </Typography>
                  <FormControlLabel
                    control={
                      <AntSwitch
                        checked={item?.status}
                        onChange={() =>
                          handleSwitchChange(panel?.id, item?.id, item?.value, item?.status)
                        }
                        inputProps={{ 'aria-label': 'ant design' }}
                      />
                    }
                  />
                </div>
              ))}
            </AccordionDetails>
          )}
        </Accordion>
      ))}
    </div>
  );
}
